import { render, staticRenderFns } from "./TransposonFamilyDetail.vue?vue&type=template&id=c1fb1a9a&scoped=true"
import script from "./TransposonFamilyDetail.vue?vue&type=script&lang=js"
export * from "./TransposonFamilyDetail.vue?vue&type=script&lang=js"
import style0 from "./TransposonFamilyDetail.vue?vue&type=style&index=0&id=c1fb1a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fb1a9a",
  null
  
)

export default component.exports